import { event } from 'vue-gtag';

interface IGoogleAnalyticsApiEventParams {
  category?: string;
  label?: string;
  value?: unknown;
  description?: string;
}

export enum GoogleAnalyticsEventCategory {
  Isochrone = 'isochrone',
  ErrorNotification = 'error_notification',
}

export default class GoogleAnalyticsApi {
  static sendEvent(action: string, params?: IGoogleAnalyticsApiEventParams) {
    event(
      action,
      params != null
        ? {
            event_category: params.category,
            event_label: params.label,
            value: params.value,
            description: params.description,
          }
        : {},
    );
  }

  static pageView(path: string) {
    event('page_view', {
      page_path: path,
    });
  }
}
